import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextControls from './textControls';
export default class TreeNodeText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false
    };
    this.handleAdd = this.handleAdd.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleHoverTrue = this.setHover.bind(this, true);
    this.handleHoverFalse = this.setHover.bind(this, false);
    this.handleChange = this.handleChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }
  setHover(hover) {
    const onHover = this.props.onHover;
    onHover(hover);
  }
  handleAdd(id) {
    const onAdd = this.props.onAdd;
    onAdd(id);
  }
  handleChange(event) {
    this.setState({
      text: event.target.value
    });
  }
  handleEdit(event) {
    let edit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const node = this.props.node;
    this.setState({
      editing: edit,
      text: node.name
    });
  }
  handleRemove() {
    const _this$props = this.props,
      onRemove = _this$props.onRemove,
      node = _this$props.node;
    onRemove(node.id);
  }
  handleSelect(event) {
    const _this$props2 = this.props,
      onSelect = _this$props2.onSelect,
      node = _this$props2.node;
    event.stopPropagation();
    onSelect(node);
  }
  handleSave() {
    const _this$props3 = this.props,
      onSelect = _this$props3.onSelect,
      onSave = _this$props3.onSave,
      node = _this$props3.node;
    const text = this.state.text;
    let name = JSON.parse(JSON.stringify(text));
    if (name.length === 0) {
      name = 'unset';
    }
    this.handleEdit({}, false);
    onSelect(null);
    onSave(_objectSpread(_objectSpread({}, node), {}, {
      name
    }));
  }
  hoverStyle() {
    const hover = this.props.hover;
    return hover ? {
      backgroundColor: '#f5f5f5',
      cursor: 'pointer'
    } : {};
  }
  render() {
    const _this$props4 = this.props,
      node = _this$props4.node,
      selected = _this$props4.selected,
      enableLinks = _this$props4.enableLinks;
    const _this$state = this.state,
      editing = _this$state.editing,
      text = _this$state.text;
    const displayText = editing ? text : node.name;
    const hoverStyle = this.hoverStyle();
    let name = node.name;
    if (name.trim().length === 0) {
      name = 'unset';
    }
    if (!node) {
      return null;
    }
    if (enableLinks) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
        href: node.href,
        style: hoverStyle
      }, displayText));
    }
    if (selected) {
      return /*#__PURE__*/React.createElement(TextControls, {
        editing: editing,
        hoverStyle: hoverStyle,
        text: displayText,
        onChange: this.handleChange,
        onSave: this.handleSave,
        onEdit: this.handleEdit,
        onRemove: this.handleRemove,
        onAdd: this.handleAdd
      });
    }
    // otherwise, return clickable text.
    return /*#__PURE__*/React.createElement("span", {
      onKeyDown: this.handleSelect,
      role: "link",
      tabIndex: 0,
      className: "t-tn-click-zone",
      onClick: this.handleSelect,
      onMouseEnter: this.handleHoverTrue,
      onMouseLeave: this.handleHoverFalse,
      style: hoverStyle
    }, name);
  }
}
TreeNodeText.propTypes = {
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onHover: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  hover: PropTypes.bool.isRequired,
  enableLinks: PropTypes.bool.isRequired,
  node: PropTypes.shape({
    name: PropTypes.string,
    href: PropTypes.string,
    state: PropTypes.string,
    id: PropTypes.string,
    nodeId: PropTypes.number
  }).isRequired
};